// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.88.1-next',
  revision: 'f15bb3e6e',
  branch: 'next',
  date: 'Tue, 30 Jun 2026 12:44:46 GMT'
};